import { AD_MIN_SECONDS } from '../../shared/economy.ts';
import type { AdCompleteResponse, AdPurpose } from '../../shared/protocol.ts';
import { showRewardedAd } from '../lib/ads.ts';
import { completeAd, startAd } from './progressionApi.ts';

const sleep = (ms: number) => new Promise((resolve) => window.setTimeout(resolve, ms));

/**
 * One rewarded ad from start to reward: get a token, show the ad, then claim.
 * A short ad is followed by a brief wait, since the server accepts a claim only
 * AD_MIN_SECONDS after the token was issued.
 */
export async function watchAd(purpose: AdPurpose): Promise<{ ok: true; data: AdCompleteResponse } | { ok: false; error: string }> {
  const start = await startAd(purpose);
  if (!start.ok) return start;
  const startedAt = Date.now();

  const outcome = await showRewardedAd(purpose === 'gold' ? 'gold' : 'shop_item');
  if (outcome !== 'viewed') return { ok: false, error: outcome };

  const wait = AD_MIN_SECONDS * 1000 + 500 - (Date.now() - startedAt);
  if (wait > 0) await sleep(wait);
  const result = await completeAd(start.data.token);
  if (!result.ok && result.error === 'too_soon') {
    await sleep(1500);
    return completeAd(start.data.token);
  }
  return result;
}
